import classes from "./Weather.module.css";
import { Fragment, useContext, useEffect, useState } from "react";
import BoxTitle from "../../box/title/BoxTitle";

import { useTranslation } from "react-i18next";

const Clock = () => {
  const { t } = useTranslation();

  const [dateTime, setDateTime] = useState("");

  useEffect(() => {
    const dt = setInterval(() => {
      getCurrentDate();
    }, 1000);

    return () => {
      clearInterval(dt);
    };
  }, []);

  const getCurrentDate = () => {
    const newDate = new Date();
    const day = newDate.getDate();
    const month = newDate.getMonth();

    const hours = newDate.getHours();
    const minutes = newDate.getMinutes();
    const seconds = newDate.getSeconds();
    const year = newDate.getFullYear();

    const fullDate = `${day < 10 ? `0${day}` : day} ${t(
      `dates.months.${month}`
    )} ${year.toString().slice(2, 4)}`;

    const fullTime = `${hours < 10 ? `0${hours}` : hours}:${
      minutes < 10 ? `0${minutes}` : minutes
    }:${seconds < 10 ? `0${seconds}` : seconds}`;

    setDateTime({
      date: fullDate,
      time: fullTime,
    });
  };

  return (
    <Fragment>
      <BoxTitle
        className={classes.weatherTitle}
        title={t("dates.title")}
        icon="im im-icon-Clock"
        element={
          <i
            id="draggable"
            className="im im-icon-Double-Tap"
            style={{
              fontSize: "32px",
              minWidth: "32px",
              color: "black",
              cursor: "pointer",
            }}
          />
        }
      />

      <div
        style={{
          display: "flex",
          flexDirection: "column",
          marginTop: "70px",
          alignItems: "center",
        }}
      >
        <span
          style={{
            color: "#fff",
            fontSize:
              dateTime?.date?.length < 15
                ? "34px"
                : dateTime?.date?.length > 14 && dateTime?.date?.length < 15
                ? "32px"
                : dateTime?.date?.length > 14 && dateTime?.date?.length < 16
                ? "30px"
                : "26px",
            fontWeight: "600",
          }}
        >
          {dateTime.date}
        </span>
        <span style={{ color: "#fff", fontSize: "62px", fontWeight: "600" }}>
          {dateTime.time}
        </span>
      </div>
    </Fragment>
  );
};

export default Clock;
